module.exports = __webpack_public_path__ + "static/img/file_jar.b157e6fc.png";